import React from 'react';
import { RedocStandalone } from 'redoc';

import empInternalApiDocs from './empInternalApiDocs.json';

function EmpInternalDocs() {
    return (
        <div>
            <RedocStandalone spec={empInternalApiDocs} options={{ scrollYOffset: 100 }} />
        </div>
    );
}

export default EmpInternalDocs;
